module.exports = __webpack_public_path__ + "static/media/27657512_1966554393608323_7893750823325001925_n.0f862fa9.jpg";